import { createSlice } from '@reduxjs/toolkit';
import { resetApplication } from '../application/slice';
import auth0State from './state';
const auth0Slice = createSlice({
    extraReducers: builder => {
        builder.addCase(resetApplication, () => auth0State);
    },
    initialState: auth0State,
    name: 'auth0',
    reducers: {
        errorReceiveAuthConnection: {
            prepare: error => {
                return {
                    payload: {
                        error
                    }
                };
            },
            reducer: (state, action) => {
                const { error } = action.payload;
                state.authConnectionError = error;
                state.requestingAuthConnection = false;
            }
        },
        errorReceiveAuthConnections: state => {
            state.requestingAuthConnections = false;
        },
        errorReceiveRemoveServerSideCookie: state => {
            state.requestingRemoveServerSideCookie = false;
        },
        errorReceiveSetServerSideCookie: state => {
            state.requestingSetServerSideCookie = false;
        },
        failedAuth0Authentication: {
            prepare: error => {
                return {
                    payload: {
                        error
                    }
                };
            },
            reducer: (state, action) => {
                const { error } = action.payload;
                state.authConnectionError = error;
            }
        },
        failedReceiveAuthConnection: {
            prepare: error => {
                return {
                    payload: {
                        error
                    }
                };
            },
            reducer: (state, action) => {
                const { error } = action.payload;
                state.authConnectionError = error;
                state.requestingAuthConnection = false;
            }
        },
        failedReceiveAuthConnections: state => {
            state.requestingAuthConnections = false;
        },
        failedReceiveRemoveServerSideCookie: state => {
            state.requestingRemoveServerSideCookie = false;
        },
        failedReceiveSetServerSideCookie: state => {
            state.requestingSetServerSideCookie = false;
        },
        receiveAuthConnection: {
            prepare: authConnection => {
                return {
                    payload: {
                        authConnection
                    }
                };
            },
            reducer: (state, action) => {
                const { authConnection } = action.payload;
                state.authConnection = authConnection;
                state.requestingAuthConnection = false;
            }
        },
        receiveAuthConnections: {
            prepare: authConnections => {
                return {
                    payload: {
                        authConnections
                    }
                };
            },
            reducer: (state, action) => {
                const { authConnections } = action.payload;
                state.authConnections = authConnections;
                state.requestingAuthConnections = false;
            }
        },
        receiveRemoveServerSideCookie: state => {
            state.requestingRemoveServerSideCookie = false;
        },
        receiveSetServerSideCookie: state => {
            state.requestingSetServerSideCookie = false;
        },
        requestAuthConnection: {
            prepare: email => {
                return {
                    payload: {
                        email
                    }
                };
            },
            reducer: state => {
                state.requestingAuthConnection = true;
            }
        },
        requestAuthConnections: state => {
            state.requestingAuthConnections = true;
        },
        requestRemoveServerSideCookie: {
            prepare: (consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI
                    }
                };
            },
            reducer: state => {
                state.requestingRemoveServerSideCookie = true;
            }
        },
        requestSetServerSideCookie: {
            prepare: (auth0Authentication, consumerAPI = false) => {
                return {
                    payload: {
                        auth0Authentication,
                        consumerAPI
                    }
                };
            },
            reducer: state => {
                state.requestingSetServerSideCookie = true;
            }
        },
        resetAuth0: () => auth0State
    }
});
export const { errorReceiveAuthConnection, errorReceiveAuthConnections, errorReceiveRemoveServerSideCookie, errorReceiveSetServerSideCookie, failedAuth0Authentication, failedReceiveAuthConnection, failedReceiveAuthConnections, failedReceiveRemoveServerSideCookie, failedReceiveSetServerSideCookie, receiveAuthConnection, receiveAuthConnections, receiveRemoveServerSideCookie, receiveSetServerSideCookie, requestAuthConnection, requestAuthConnections, requestRemoveServerSideCookie, requestSetServerSideCookie, resetAuth0 } = auth0Slice.actions;
export default auth0Slice.reducer;
